import { Spin } from "antd";
import { FC } from "react";
import classes from "./style.module.css";

const Loader: FC = () => {
  return (
    <div className={classes.__body}>
      <div className={classes.book}>
        <div className={classes.inner}>
          <div className={classes.left}></div>
          <div className={classes.middle}></div>
          <div className={classes.right}></div>
        </div>
        <ul>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
      </div>
    </div>
  );
};

export default Loader;
